export default __webpack_public_path__ + "static/media/header.05d9864e.jpg";